<!-- @format -->

<company-form>
  <form class="application_form">
    <template each="{ propName in ['company_name', 'company_kana'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
      </label>
      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <input
        class="text_input { props.errors[propName] ? 'is-error' : '' }"
        type="text"
        name="{ propName }"
        id="{ propName }"
        placeholder="{ propName == 'company_name' ? 'CROCO株式会社' : 'くろこかぶしきがいしゃ' }"
        is="binding"
        data="{ state.params }"
      />
    </template>

    <template each="{ propName in ['representative'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
      </label>
      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <input
        class="text_input { props.errors[propName] ? 'is-error' : '' }"
        type="text"
        name="{ propName }"
        id="{ propName }"
        placeholder="栗田 佳典"
        is="binding"
        data="{ state.params }"
      />
    </template>

    <h3 class="form-heading required">本社所在地</h3>
    <div class="inner_form">
      <template each="{ propName in ['zip'] }">
        <label class="form-heading required" for="{ propName }">
          { Fields[propName] }
        </label>
        <p if="{ props.errors[propName] }" class="error">
          { props.errors[propName] }
        </p>
        <input
          class="text_input { props.errors[propName] ? 'is-error' : '' }"
          type="text"
          name="{ propName }"
          id="{ propName }"
          placeholder="0000000"
          is="binding"
          data="{ state.params }"
        />
      </template>

      <template each="{ propName in ['pref'] }">
        <label class="form-heading required" for="{ propName }">
          {Fields[propName]}
        </label>
        <p if="{ props.errors[propName] }" class="error">
          { props.errors[propName] }
        </p>
        <select
          name="{ propName }"
          id="{ propName }"
          class="text_input narrow sort-list"
          onchange="{ onPref }"
        >
          <option each="{ pref in props.prefs }" value="{ pref.id }">
            { pref.jname }
          </option>
        </select>
      </template>

      <template each="{ propName in ['address1'] }">
        <label class="form-heading required" for="{ propName }">
          { Fields[propName] }
        </label>
        <p if="{ props.errors[propName] }" class="error">
          { props.errors[propName] }
        </p>
        <input
          class="text_input { props.errors[propName] ? 'is-error' : '' }"
          type="text"
          name="{ propName }"
          id="{ propName }"
          placeholder="渋谷区代々木4-33-10"
          is="binding"
          data="{ state.params }"
        />
      </template>

      <template each="{ propName in ['address2'] }">
        <label class="form-heading" for="{ propName }">
          { Fields[propName] }
        </label>
        <p if="{ props.errors[propName] }" class="error">
          { props.errors[propName] }
        </p>
        <input
          class="text_input { props.errors[propName] ? 'is-error' : '' }"
          type="text"
          name="{ propName }"
          id="{ propName }"
          placeholder="トーシンビル6階"
          is="binding"
          data="{ state.params }"
        />
      </template>
    </div>
    <!--/.inner_form-->

    <template each="{ propName in ['url'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
      </label>
      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <input
        class="text_input { props.errors[propName] ? 'is-error' : '' }"
        type="text"
        name="{ propName }"
        id="{ propName }"
        placeholder="https://cro-co.co.jp/"
        is="binding"
        data="{ state.params }"
      />
    </template>

    <template each="{ propName in ['tel'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
      </label>
      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <input
        class="text_input narrow { props.errors[propName] ? 'is-error' : '' }"
        type="text"
        name="{ propName }"
        id="{ propName }"
        placeholder="0000000000"
        is="binding"
        data="{ state.params }"
      />
    </template>

    <template each="{ propName in ['content'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
      </label>
      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <textarea
        class="textarea_input { props.errors[propName] ? 'is-error' : '' }"
        name="content"
        value="{ state.params.content }"
        onkeyup="{ onTextarea }"
        onchange="{ onTextarea }"
      ></textarea>
    </template>

    <label class="form-heading required" for="established">設立</label>
    <p if="{ props.errors.established_year }" class="error">
      { props.errors.established_year }
    </p>
    <p if="{ props.errors.established_month }" class="error">
      { props.errors.established_month }
    </p>
    <div class="container_input">
      <input
        class="text_input extra_narrow { props.errors.established_year ? 'is-error' : '' }"
        type="text"
        name="established_year"
        id="established"
        is="binding"
        data="{ state.params }"
      />
      <p>年</p>
      <input
        class="text_input extra_narrow { props.errors.established_month ? 'is-error' : '' }"
        type="text"
        name="established_month"
        id="established_m"
        is="binding"
        data="{ state.params }"
      />
      <p>月</p>
    </div>
    <!--/.container_input-->

    <template each="{ propName in ['capital'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
      </label>
      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <div class="container_input">
        <input
          class="text_input narrow"
          type="text"
          name="{ propName }"
          id="{ propName }"
          is="binding"
          data="{ state.params }"
        />
        <p>円</p>
      </div>
    </template>
    <!--/.container_input-->

    <h3 class="form-heading required">上場</h3>
    <div class="container_input">
      <input
        type="radio"
        name="listed"
        id="unlisted"
        class="radio_input"
        checked="{ state.listed == '0' }"
        val="0"
        is="binding"
        data="{ state.params }"
      />
      <label for="unlisted" class="radio_label">非上場</label>
      <input
        type="radio"
        name="listed"
        id="listed"
        class="radio_input"
        checked="{ state.listed == '1' }"
        val="1"
        is="binding"
        data="{ state.params }"
      />
      <label for="listed" class="radio_label">上場</label>
    </div>
    <!--/.container_input-->
    <template each="{ propName in ['code'] }">
      <label class="form-heading required" for="{ propName }">
        { Fields[propName] }
        <span if="{propName == 'code'}">(13桁)</span>
      </label>

      <p>
        ご不明な場合は、
        <a href="https://www.houjin-bangou.nta.go.jp/" target="_blank">
          こちら
        </a>
        からご確認ください
      </p>

      <p if="{ props.errors[propName] }" class="error">
        { props.errors[propName] }
      </p>
      <input
        class="text_input narrow"
        type="text"
        name="{ propName }"
        id="{ propName }"
        val="1"
        is="binding"
        data="{ state.params }"
        maxlength="13"
      />
    </template>

    <div class="container_button">
      <button
        class="button button-primary"
        type="button"
        value="確認画面へ"
        data-target=""
        onclick="{ onSubmit }"
      >
        確認画面へ
      </button>
    </div>
    <!--/.container_button-->
  </form>

  <script>
    import di from "dependeny-injection";

    export default {
      Fields: {
        company_name: "会社名",
        company_kana: "会社名(かな)",
        representative: "代表者氏名",
        zip: "郵便番号",
        pref: "都道府県",
        address1: "住所1（市区町村 番地）",
        address2: "住所2（建物名、フロアなど）",
        url: "ホームページアドレス",
        tel: "電話番号",
        content: "事業内容",
        established_year: "設立年",
        established_month: "設立月",
        capital: "資本金",
        listed: "上場",
        code: "法人番号",
      },
      state: {
        params: {},
        errors: {},
      },
      onBeforeMount(props, state) {
        const isEmpty = Object.keys(props.params).length == 0;
        for (const key of Object.keys(this.Fields)) {
          this.state.params[key] = isEmpty ? "" : props.params[key];
        }
        if (!this.state.params.listed) {
          this.state.params.listed = "0";
        }
      },
      onMounted(props, state) {
        this.onUpdated(props, state);
      },
      onUpdated(props, state) {
        this.$('[name="pref"]').value = state.params.pref;
      },
      onPref(e) {
        this.state.params.pref = e.target.value;
      },
      onTextarea(e) {
        this.state.params.content = e.target.value;
      },
      onSubmit(e) {
        this.props.confirmation(this.state.params);
      },
    };
  </script>
</company-form>
